import { render, staticRenderFns } from "./AddNewIp.vue?vue&type=template&id=9ff03e66&scoped=true&"
import script from "./AddNewIp.vue?vue&type=script&lang=js&"
export * from "./AddNewIp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff03e66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ff03e66')) {
      api.createRecord('9ff03e66', component.options)
    } else {
      api.reload('9ff03e66', component.options)
    }
    module.hot.accept("./AddNewIp.vue?vue&type=template&id=9ff03e66&scoped=true&", function () {
      api.rerender('9ff03e66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Security/BlockedIp/AddNewIp.vue"
export default component.exports